import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, mergeProps as _mergeProps, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01cca92e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6 items-center" }
const _hoisted_2 = { class: "md:col-span-1 lg:col-span-2" }
const _hoisted_3 = { class: "md:col-span-1 lg:col-span-1" }
const _hoisted_4 = { class: "md:col-span-2 lg:col-span-1" }
const _hoisted_5 = { class: "flex flex-col gap-6" }
const _hoisted_6 = { class: "overflow-x-auto rounded-lg shadow-sm border border-gray-200 min-h-[300px]" }

import { computed, ref, onMounted } from 'vue'
import DsPoliciesTab from './ds.policies.tab.vue'
import DsPolicyTableSkeleton from '@/components/designSystem/Skeleton/DsPolicyTableSkeleton.vue'

import { useDsPolicyStore } from '@/pinia-store/useDsPolicyStore'
import { EModals, useModalStore } from '@/pinia-store/useModalStore'

import { mdiFilter, mdiPlus } from '@mdi/js'

import CreateDsPolicyModal from './components/CreateDsPolicyModal/Index.vue'
import EmptyList from '@/components/EmptyList.vue'
import ReportErrorState from '@/components/designSystem/ErrorState/ReportErrorState.vue'
import SearchInput from '@/components/designSystem/Inputs/SearchInput.vue'
import FilterModal from './components/FilterDsPoliciesModal/FilterModal.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'
import { useHeaderStore } from '@/pinia-store/useHeaderStore'
import PATHS from '@/router/paths'

interface Filters {
  search: string
  companies: string[]
  isActive: 'active' | 'inactive' | ''
  authorizationStatus?: 'FULLY_AUTHORIZED' | 'PARTIALLY_AUTHORIZED' | ''
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const showModalCreateUser = ref(false)
const textInput = ref('')
const filterModalProps = ref(false)
const currentPage = ref(1)

const modalStore = useModalStore()
const policyStore = useDsPolicyStore()
// const companyStore = useCompanyStore()
const permissionsStore = usePermissionsStore()

const headerStore = useHeaderStore()

const loading = computed(() => policyStore.isLoading)

// TODO - Voltar após atualizar o schema
// const canCreatePolicy = computed(() => {
//   return permissionsStore.checkAnyRessources({
//     permission: AuthorizationPermissions.CompanyPolicyCreatingGranted,
//     resourceType: AuthorizationResourcesAndSubjects.Company
//   })
// })

const canCreatePolicy = computed(() => {
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.StationCreating,
    resourceType: AuthorizationResourcesAndSubjects.Schedule
  })
})

const pageCount = computed(() =>
  Math.ceil(policyStore.totalPolicies / policyStore.policyQuery.limit!)
)

const changePage = (page: number) => {
  currentPage.value = page
  policyStore.changePage(page)
}

onMounted(() => {
  headerStore.setTitle(
    'Política de Restrição',
    'Gerencie políticas de autorização de médicos, status e vínculos com empresas',
    { label: 'Políticas', route: PATHS.POLICIES_HOME }
  )

  if (policyStore.policyQuery) {
    policyStore.policyQuery.limit = 6
  }
  policyStore.fetchDsPolicies()
})

const onSearchByTabIndex = async () => {
  await policyStore.applyFilters({ ...policyStore.policyQuery, q: textInput.value })
}

const toggleCreateModal = () => {
  showModalCreateUser.value = !showModalCreateUser.value
  modalStore.toggleModal(EModals.CREATE_GROUP_MODAL)
}

const toggleModalCreateUser = () => {
  showModalCreateUser.value = false
}

const openFilterModal = () => {
  textInput.value = ''
  filterModalProps.value = true
}

const closeFilterModal = () => {
  filterModalProps.value = false
}

const appliedFilters = ref<Filters>({
  search: '',
  companies: [],
  isActive: '',
  authorizationStatus: ''
})

const applyFilters = (filters: Filters) => {
  appliedFilters.value = filters

  let isActiveValue: boolean | undefined = undefined
  if (filters.isActive === 'active') {
    isActiveValue = true
  } else if (filters.isActive === 'inactive') {
    isActiveValue = false
  }

  policyStore.applyFilters({
    q: appliedFilters.value.search,
    companyIds: appliedFilters.value.companies.join(','),
    isActive: isActiveValue,
    authorizationStatus: appliedFilters.value.authorizationStatus || undefined,
    limit: 6
  })

  filterModalProps.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(SearchInput, {
          modelValue: textInput.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((textInput).value = $event)),
          onInput: onSearchByTabIndex,
          width: "100%",
          loading: loading.value,
          label: `Buscar políticas`,
          "hide-details": ""
        }, null, 8, ["modelValue", "loading"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(OutlinedButton, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (openFilterModal())),
          text: 'Filtrar',
          width: "100%",
          height: "56px",
          "prepend-icon": _unref(mdiFilter)
        }, null, 8, ["prepend-icon"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_v_tooltip, { location: "top" }, {
          activator: _withCtx(({ props }) => [
            _createElementVNode("div", _mergeProps(props, {
              class: ["w-full", [!canCreatePolicy.value ? 'cursor-not-allowed' : '']]
            }), [
              _createVNode(FilledButton, {
                disabled: !canCreatePolicy.value,
                onClick: toggleCreateModal,
                text: `Nova política`,
                width: "100%",
                height: "56px",
                "prepend-icon": _unref(mdiPlus),
                class: _normalizeClass([!canCreatePolicy.value ? 'pointer-events-none ' : '!bg-primary30'])
              }, null, 8, ["disabled", "prepend-icon", "class"])
            ], 16)
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(canCreatePolicy.value ? 'Criar nova política' : 'Você não tem permissão para criar'), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_unref(policyStore).isLoading)
          ? (_openBlock(), _createBlock(DsPolicyTableSkeleton, { key: 0 }))
          : (_unref(policyStore).hasError)
            ? (_openBlock(), _createBlock(ReportErrorState, {
                key: 1,
                title: "Não foi possível carregar as políticas",
                message: _unref(policyStore).loadError,
                onRetry: _cache[2] || (_cache[2] = ($event: any) => (_unref(policyStore).fetchDsPolicies()))
              }, null, 8, ["message"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_unref(policyStore).policies.length > 0)
                  ? (_openBlock(), _createBlock(DsPoliciesTab, {
                      key: 0,
                      policies: _unref(policyStore).policies
                    }, null, 8, ["policies"]))
                  : (_openBlock(), _createBlock(EmptyList, {
                      key: 1,
                      title: "Nenhuma política encontrada",
                      class: "py-12"
                    }))
              ], 64))
      ]),
      (!_unref(policyStore).isLoading && _unref(policyStore).policies.length > 0)
        ? (_openBlock(), _createBlock(_component_v_pagination, {
            key: 0,
            modelValue: currentPage.value,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = ($event: any) => ((currentPage).value = $event)),
              changePage
            ],
            "total-visible": 5,
            length: pageCount.value,
            density: "comfortable",
            color: "primary",
            class: "mt-4"
          }, null, 8, ["modelValue", "length"]))
        : _createCommentVNode("", true)
    ]),
    (showModalCreateUser.value)
      ? (_openBlock(), _createBlock(CreateDsPolicyModal, {
          key: 0,
          onClose: toggleModalCreateUser,
          modalActive: showModalCreateUser.value
        }, null, 8, ["modalActive"]))
      : _createCommentVNode("", true),
    (filterModalProps.value)
      ? (_openBlock(), _createBlock(FilterModal, {
          key: 1,
          "show-status-filter": true,
          modalStateProp: filterModalProps.value,
          onClose: closeFilterModal,
          onApplyFilters: applyFilters,
          "applied-filters": appliedFilters.value
        }, null, 8, ["modalStateProp", "applied-filters"]))
      : _createCommentVNode("", true)
  ]))
}
}

})